import { NavigateFunction } from 'react-router-dom';
import { AnyAction, Dispatch } from 'redux';
import { AppState } from '../../../store/store';
import { ThunkResult } from './ThunkResult';
import AnalyticsEventUtil from '../../../infra/analytics/analytics-event-util';

export const navigateToClientBookedAppointmentsScreenAction = (navigate: NavigateFunction, clientUserProfileId: string): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    AnalyticsEventUtil.getInstance().navigateToClientBookedAppointmentsScreen(clientUserProfileId);
    navigate(`/booked-appointments/${clientUserProfileId}`);
  };
};